module.exports = __webpack_public_path__ + "static/media/status-pending.b9a1faaf.svg";